export const oacOptions = [
  'No Current OAC',
  'On OAC [Unspecified Type]',
  'Watchman / LAAOD',
  'Unable to Tolerate',
  'Patient Refused',
  'Low CHA₂DS₂-VASc / Not Indicated',
  'Fall Risk',
  'Aspirin Only',
  'Apixaban (Eliquis)',
  'Apixaban (Eliquis) 2.5mg',
  'Apixaban (Eliquis) 5mg',
  'Rivaroxaban (Xarelto)',
  'Rivaroxaban (Xarelto) 2.5mg',
  'Rivaroxaban (Xarelto) 10mg',
  'Rivaroxaban (Xarelto) 15mg',
  'Rivaroxaban (Xarelto) 20mg',
  'Dabigatran (Pradaxa)',
  'Dabigatran (Pradaxa) 75mg',
  'Dabigatran (Pradaxa) 110mg',
  'Dabigatran (Pradaxa) 150mg',
  'Edoxaban (Savaysa)',
  'Edoxaban (Savaysa) 15mg',
  'Edoxaban (Savaysa) 30mg',
  'Edoxaban (Savaysa) 60mg',
  'Warfarin (Coumadin)',
  'Warfarin (Coumadin) 1mg',
  'Warfarin (Coumadin) 2mg',
  'Warfarin (Coumadin) 2.5mg',
  'Warfarin (Coumadin) 3mg',
  'Warfarin (Coumadin) 4mg',
  'Warfarin (Coumadin) 5mg',
  'Warfarin (Coumadin) 6mg',
  'Warfarin (Coumadin) 7.5mg',
  'Warfarin (Coumadin) 10mg'
].map((label) => ({ label, value: label }));
